import { PropsWithChildren } from 'react'
import Styles from './Field.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface Props
  extends PropsWithChildren<{
    label: string
    isRequired?: boolean
  }> {}

export const Field = ({ children, label, isRequired }: Props) => {
  return (
    <div className={Styles.field}>
      <Text variant="largeList">
        {label}
        {isRequired && <span className={Styles.star}>&nbsp;*</span>}
      </Text>
      {children}
    </div>
  )
}
